module.exports = __webpack_public_path__ + "img/step_03.cb5d790e.png";